import { render, staticRenderFns } from "./downloads-filter.vue?vue&type=template&id=f68a57c6&"
import script from "./downloads-filter.vue?vue&type=script&lang=js&"
export * from "./downloads-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports